<style lang="less" scoped>
@import '../../../style/common/variable';
// .imgMain{position: relative;width: 1180px;padding: 0px;margin:0;margin-left: 10px;font-family: AlibabaPuHuiTi-Regular;}
//   ul {list-style: none;padding: 0px;margin: 0;margin-bottom: 50px; display: flex;flex-wrap: wrap;}
//   li {margin-top: 16px;width: 578px;height: 210px;background-color: #ffffff;box-shadow: 0px 0px 8px 2px rgb(214, 214, 214);display: flex;}
//   li:nth-child(2n+1){margin-right: 20px;}
//   li:hover{cursor: pointer;.title{color: rgb(31, 104, 192);}}
//   .picBox{width: 260px;height: 160px;overflow: hidden;}
//   img{width: 260px;height: 160px;margin: 24px 16px;}
//   .box{width: 280px;height: 160px;margin: 24px 0px;overflow: hidden;}
//     .title{width: 276px;margin:0;text-align: left;font-size: 16px;font-weight: 600; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
//     .introduce{width: 276px;margin:0;margin-top: 18px;line-height: 20px; text-align: left;font-size: 14px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;text-align: justify;}
@media screen and (min-width: @max-screen){
  .imgMain{position: relative;width: 1180px;padding: 0px;margin:0;margin-left: 10px;font-family: AlibabaPuHuiTi-Regular;}
  ul {list-style: none;padding: 0px;margin: 0;margin-bottom: 50px; display: flex;flex-wrap: wrap;}
  li {margin-top: 16px;width: 578px;height: 210px;background-color: #ffffff;box-shadow: 0px 0px 8px 2px rgb(214, 214, 214);display: flex;}
  li:nth-child(2n+1){margin-right: 20px;}
  li:hover{cursor: pointer;.title{color: rgb(31, 104, 192);}}
  .picBox{width: 260px;height: 160px;overflow: hidden;}
  img{width: 260px;height: 160px;margin: 24px 16px;}
  .box{width: 280px;height: 160px;margin: 24px 0px;overflow: hidden;}
    .title{width: 276px;margin:0;text-align: left;font-size: 16px;font-weight: 600; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
    .introduce{width: 276px;margin:0;margin-top: 18px;line-height: 20px; text-align: left;font-size: 14px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;text-align: justify;}

}
@media screen and (max-width: @max-screen){
  .imgMain{position: relative;width: 95%;padding: 0px;margin:0;margin-left: 10px;font-family: AlibabaPuHuiTi-Regular;}
  ul {list-style: none;padding: 0px;margin: 0;margin-bottom: 50px; display: flex;flex-wrap: wrap;}
  li {margin-top: 16px;width: 100%;height: 210px;background-color: #ffffff;box-shadow: 0px 0px 8px 2px rgb(214, 214, 214);display: flex;}
  // li:nth-child(2n+1){margin-right: 20px;}
  li:hover{cursor: pointer;.title{color: rgb(31, 104, 192);}}
  .picBox{width: 260px;height: 160px;overflow: hidden;}
  img{height: 160px;margin: 24px 16px;}
  .box{width: 60%;height: 160px;margin: 24px 10px;overflow: hidden;}
    .title{width: 100%;margin:0;text-align: left;font-size: 12px;font-weight: 600; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
    .introduce{width: 100%;margin:0;margin-top: 18px;line-height: 20px; text-align: left;font-size: 12px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;text-align: justify;}

}
</style>

<template>
  <div class="imgMain">
    <ul>
      <li v-for="(item,index) in imgMainList" :key="index" @click="handleClick(item)">
        <img :src="item.thumb" />
        <div class="box">
          <p class="title"> {{ item.title }} </p>
          <p class="introduce"> {{ item.introduce }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽
 * 2022.4.14
 * 首页东盟地学板块组件，展示4条数据，每条数据左侧为图片，右侧为标题及内容
 */
export default {
  props: ['imgMainList'],
  data()
  {
    return {}
  },
  methods: {
    // 点击 图片或标题， 将整个对象传递给父组件
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ImgMain.vue